import {
  useState,
  Dispatch,
  SetStateAction,
  useRef,
  MutableRefObject,
} from "react";

function useStateRef<S>(
  initialState: S | (() => S),
): [S, Dispatch<SetStateAction<S>>, MutableRefObject<S>] {
  const [value, setValue] = useState<S>(initialState);
  const ref = useRef<S>(value);
  ref.current = value;

  const setState = (state: S | ((pre: S) => S)) => {
    if (typeof state === "function") {
      setValue((p: S) => {
        const next = (state as (pre: S) => S)(p);
        ref.current = next;
        return next;
      });
    } else {
      ref.current = state;
      setValue(state);
    }
  };

  return [value, setState, ref];
}

export default useStateRef;
